/* Solfuerza Blitzdeals – Countdown bis Mitternacht (Europe/Berlin) für alle [data-bz-countdown] */
(function () {
  if (window.__sfBlitz) return;
  window.__sfBlitz = true;
  var fmt;
  try {
    fmt = new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
  } catch (e) { fmt = null; }
  function berlinSeconds() {
    var d = new Date();
    if (!fmt) return d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds();
    var parts = fmt.formatToParts(d), h = 0, m = 0, s = 0;
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (p.type === 'hour') h = parseInt(p.value, 10) % 24;
      else if (p.type === 'minute') m = parseInt(p.value, 10);
      else if (p.type === 'second') s = parseInt(p.value, 10);
    }
    return h * 3600 + m * 60 + s;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var left = 86400 - berlinSeconds();
    if (left >= 86400) left = 0;
    var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
    var els = document.querySelectorAll('[data-bz-countdown]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var eh = el.querySelector('[data-bz-h]'), em = el.querySelector('[data-bz-m]'), es = el.querySelector('[data-bz-s]');
      if (eh) eh.textContent = pad(h);
      if (em) em.textContent = pad(m);
      if (es) es.textContent = pad(s);
      var inl = el.querySelector('[data-bz-inline]');
      if (inl) inl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    if (left <= 1 && !window.__sfBlitzReloaded) {
      /* Tageswechsel: neue Deals laden */
      window.__sfBlitzReloaded = true;
      setTimeout(function () { try { location.reload(); } catch (e) {} }, 65000);
    }
  }
  tick();
  setInterval(tick, 1000);

  /* Produktseite: Hinweis-Box über den Kaufbereich setzen */
  function placePdp() {
    var box = document.getElementById('sf-blitz-pdp');
    if (!box || box.dataset.placed) return;
    var target = document.querySelector('.product-info product-form, .product-info .product-form, .product-info form[action*="/cart/add"], form[action*="/cart/add"].product-form, .product-info .buy-buttons, .product-info__price, .product-info .price');
    if (!target) return;
    box.dataset.placed = '1';
    box.hidden = false;
    var anchor = target.closest('.product-info > *') || target;
    anchor.parentNode.insertBefore(box, anchor);
  }
  /* Startseite: statische Section direkt unter den Black-Friday-Hub (sonst unter den Hero) setzen */
  function placeHome() {
    var sec = document.getElementById('shopify-section-sf-blitzdeals');
    if (!sec || sec.dataset.placed) return;
    var after = document.querySelector('#MainContent > .shopify-section[id$="__sf_bf_home"], #MainContent > #shopify-section-sf_bf_home') || document.querySelector('#MainContent > .shopify-section[id$="__sf_hero"], #MainContent > #shopify-section-sf_hero') || document.querySelector('#MainContent > .shopify-section');
    if (!after || after === sec) return;
    sec.dataset.placed = '1';
    after.parentNode.insertBefore(sec, after.nextSibling);
  }
  function place() { placePdp(); placeHome(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
  setTimeout(place, 800);
  setTimeout(place, 2500);
})();
